import {cache0} from "../../utils/cache0";

import {isDevXd} from "./is-dev";

//https://xpresso.awsdev.xpressdocs.com

export const isXdQaTagsViewer = cache0(()=> (
    !!sessionStorage.XD_QA_TAGS_VIEWER || !!localStorage.XD_QA_TAGS_VIEWER ||
    isDevXd() ||
    location.hostname.endsWith(".awsdev.xpressdocs.com") ||
    location.hostname === "www-stagetre.xpressdocs.com" ||
    false
));
